<template>
  <div
    class="pa-0 main__light_green"
    data-qa="add-formula">
    <CustomTextarea
      v-if="show_input"
      ref="input"
      autofocus
      class="mb-0"
      clearable
      data-qa="formula-textarea"
      :error="!!errors_in_formula.length"
      :max_length="max_length"
      :placeholder="$t('Tenders.EnterFormula')"
      rounded
      rows="1"
      :rules="[findError]"
      :value.sync="new_formula"
      @action="findVariable"
      @blur="blur"
      @click_clear="findVariable"
      @immediately="checkDots"/>
    <div
      v-else
      class="show-formula text-start flex">
      <div
        ref="html_formula_block"
        class="white valid-formula flex flex-between h7-text align-center"
        :class="{'invalid': errors_in_formula.length}"
        data-qa="formula-block"
        @click="openInput">
        <div
          v-dompurify-html="html_formula"
          class="h7-text black--text valid-formula-value"/>
        <sButton
          icon="cross"
          small
          type="text"
          @click="click_clear"/>
      </div>
    </div>
    <div
      v-if="errors_in_formula.length && error_text"
      class=" h8-text mt-0 secondary__red--text text-start mb-4"
      data-qa="formula-error"
      style="margin-left: 14px ">
      {{ error_text }}
    </div>
    <v-subheader class="h6-text pa-0 mt-1 black--text text-start">
      {{ $t("Tenders.ChangeFormula") }}
    </v-subheader>
  </div>
</template>

<script>
import CustomTextarea from 'components/common/inputs/CustomTextarea.vue'

import { mapGetters } from 'vuex'
import { criteriasMixin } from 'mixins'
import godModeMixin from 'mixins/godModeMixin'

export default {
  name: 'addFormula',
  mixins: [ criteriasMixin, godModeMixin ],
  data() {
    return {
      new_variables: [],
      html_formula: '',
      errors_in_formula: [],
      error_text: '',
      show_input: false
    }
  },
  props: {
    formula: String,
    subheader: Boolean,
    error: [Boolean, String],
    variables: Array,
    max_length: [String, Number],
    /**
     *  карта для збереження в localStorage
     */
    card: Object,
  },
  mounted() {
    this.findError(this.new_formula)
    this.validateFormula()
  },
  computed: {
    ...mapGetters({
      tender: 'getNewTender',
    }),
    new_formula: {
      get() {
        return this.formula
      },
      set(val) {
        this.$emit('update:formula', val)
      }
    },
  },
  methods: {
    blur() {
      this.validateFormula()
      this.saveCardToLocalStorage(this.tender, this.card)
    },
    checkDots(text) {
      this.new_formula = text.replaceAll( ',', '.')
    },
    openInput() {
      this.show_input = true
      this.$nextTick(() => {
        this.$refs?.input?.$refs?.bordered_textarea?.validate(this.new_formula)
      })
    },
    validateFormula(check_empty) {

      if ( check_empty && !this.new_formula?.length ) {
        this.errors_in_formula = ['']
      }
      this.new_formula = this.new_formula?.trim()

      this.html_formula = this.validateFormulaByErrors(this.new_formula, this.errors_in_formula)

      this.show_input = !this.new_formula?.length

      this.$nextTick(() => {
        let ref = this.$refs.html_formula_block
        if (!ref) { return }
        if (ref.clientHeight > 45) {
          ref.style.borderRadius = '8px'
        } else {
          ref.style.borderRadius = '31px'
        }
      })
    },
    findError(item) {
      item = item?.replaceAll(/\s{2,}/g, ' ')
      if ( this.$refs?.input?.$refs?.bordered_textarea ) {
        this.$refs.input.$refs.bordered_textarea.lazyValue = item
      }
      this.new_formula = item

      let errors = this.findFormulaErrors(item, this.variables)
      let result = !errors.all_errors || errors.all_errors.join(', ')
      this.errors_in_formula = errors.all_errors

      this.$emit('update:error', !!result)

      if (!this.mixin_isGodMode && errors.not_variables.length) {
        this.error_text = errors.not_variables.join(', ') + ' - ' + this.$t('Tenders.NotAvailableVariables')
      } else {
        this.error_text = ''
      }
      return result ? result : true
    },
    findVariable() {
      if ( !this.new_formula ) {
        this.new_variables = []
      } else {
        let variable = this.new_formula?.match(/(?<variableName>[a-zA-Z]+\b)/g)
        if (variable && typeof this.error != 'string') {
          this.new_variables = this.$_.uniq(variable)
        }
      }
    },
    click_clear() {
      this.new_formula = ''
      this.$nextTick(this.validateFormula)
    },
    updFormula() {
      this.findError(this.new_formula)

      this.validateFormula()
    }
  },
  watch: {
    variables() {
      this.updFormula()
    }
  },
  components: {
    CustomTextarea
  }
}
</script>

<style lang="scss" scoped>
.valid-formula {
  border-radius: 31px;
  width: 100%;
  min-height: 40px;
  border: 2px solid var(--v-main__green-base) !important;
  padding: 0 5px 0 10px;
  &.invalid{
    border: 2px solid var(--v-secondary__red-base) !important;
  }
  .valid-formula-value {
    vertical-align: middle;
    padding: 8px  0 ;
    min-height: 20px;
    letter-spacing: normal;
  }
}

</style>
